var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 24,
    maskUnits: "userSpaceOnUse",
    width: 24,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "#d9d9d9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 21.325c-.2333 0-.4667-.0417-.7-.125s-.4417-.2083-.625-.375c-1.08333-1-2.04167-1.975-2.875-2.925s-1.52917-1.8708-2.0875-2.7625-.98333-1.75-1.275-2.575-.4375-1.6125-.4375-2.3625c0-2.5.80417-4.49167 2.4125-5.975s3.47083-2.225 5.5875-2.225c2.1167 0 3.9792.74167 5.5875 2.225s2.4125 3.475 2.4125 5.975c0 .75-.1458 1.5375-.4375 2.3625s-.7167 1.6833-1.275 2.575-1.2542 1.8125-2.0875 2.7625-1.7917 1.925-2.875 2.925c-.1833.1667-.3917.2917-.625.375s-.4667.125-.7.125zm0-9.325c.55 0 1.0208-.1958 1.4125-.5875s.5875-.8625.5875-1.4125-.1958-1.02083-.5875-1.4125-.8625-.5875-1.4125-.5875-1.0208.19583-1.4125.5875-.5875.8625-.5875 1.4125.1958 1.0208.5875 1.4125.8625.5875 1.4125.5875z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.affbd708a0ae688c3bdac18e1a01fdfd.svg";
export { ForwardRef as ReactComponent };